import React, { useEffect } from "react";
import { Routes, Route, useLocation } from 'react-router-dom';
import Main from "./Components/main";
import Calander from "./Components/Calander/calander";
import ProtectedRoute from "./auth/protected-route";
import AdminRoute from "./auth/admin-route";
import CapabilityRoute from "./auth/capability-route";
import SEODashboard from "./Components/MockPages/SEODashboard"
import Synthora from "./Pages/Synthora";
import SynthoraHub from "./Pages/SynthoraHub";
import OnboardingForm from './Pages/OnboardingForm';
import ProfilePage from "./Pages/ProfilePage";
import WorkspacePage from "./Pages/WorkspacePage";
import AdminPanel from "./Pages/AdminPanel";
import ContactUs from "./Components/MockPages/ContactUs";
import VideoCallPage from "./Pages/video-call/VideoCallPage";
import WhiteboardPage from "./Pages/whiteboard/WhiteboardPage";
import MondayCalendarTest from "./Components/MockPages/MondayCalendarTest";
import MondayCalendarScheduler from "./Components/MockPages/MondayCalendarScheduler";
import PaymentsManagement from "./Components/PaymentsManagement";
import FirmStandards from "./Pages/FirmStandards";
import ProgramsPipelinesPage from "./Pages/ProgramsPipelinesPage";
import TeachProgramPage from "./Pages/TeachProgramPage";
import TestBenchPage from "./Pages/TestBenchPage";
import StaffingPositionsPage from "./Pages/StaffingPositionsPage";
import DeveloperRoute from "./auth/developer-route";
import FormDetails from "./Pages/FormDetails";
import FormFillingGate from "./Pages/FormFillingGate";
import { FlowBuilderReactFlow, FlowBuilderBlocks, FlowBuilderForms } from "./Pages/FlowBuilder";
import TokenSettings from "./Components/TokenSettings/TokenSettings";
import CoPilotPage from "./Pages/CoPilotPage";
import { CampaignsPage } from "./Components/Campaigns";
import AcceptInvitePage from "./Pages/AcceptInvitePage";
import TeamLoginPage from "./Pages/TeamLoginPage";
import MemberLoginPage from "./Pages/MemberLoginPage";
import ServiceQuestionnairePage from "./Pages/ServiceQuestionnairePage";
import UnsubscribePage from "./Pages/UnsubscribePage";
import FeedbackDetailPage from "./Components/Feedback/FeedbackDetailPage";
import NetworkPage from "./Pages/NetworkPage";
import AgentPage from "./Pages/AgentPage";
import LiveCheckPage from "./Pages/LiveCheckPage";
import AgentHistoryPage from "./Pages/AgentHistoryPage";
import AgentBuilderPage from "./Pages/AgentBuilder";
import ReferralConsentPage from "./Pages/ReferralConsentPage";
import Agreements from "./Components/Agreements";

export default function Router({ allowResizing, allowDragging, allowFloating }) {

  const location = useLocation();

  useEffect(() => {
    if (window.plausible) {
      window.plausible('pageview');
    }
  }, [location]);

  return (
    <div style={{ flex: 1, overflow: 'auto', height: '100%' }}>
      <section style={{ height: '100%', overflow: 'hidden' }}>
        <Routes>
          <Route path="/" element={<ProtectedRoute><SEODashboard /></ProtectedRoute>}></Route>
          <Route path="/main" element={
            <ProtectedRoute>
              <Main
                allowResizing={allowResizing}
                allowDragging={allowDragging}
                allowFloating={allowFloating}
              />
            </ProtectedRoute>
          }></Route>
          <Route path="/main/:threadId" element={
            <ProtectedRoute>
              <Main
                allowResizing={allowResizing}
                allowDragging={allowDragging}
                allowFloating={allowFloating}
              />
            </ProtectedRoute>
          }></Route>
          <Route path="/calendar" element={<ProtectedRoute><Calander /></ProtectedRoute>}></Route>
          <Route path="/workspace/:threadId" element={<ProtectedRoute><WorkspacePage /></ProtectedRoute>}></Route>
          <Route path="/main/:threadId" element={<ProtectedRoute><WorkspacePage /></ProtectedRoute>}></Route>
          <Route path="/workspace" element={<ProtectedRoute><WorkspacePage /></ProtectedRoute>}></Route>
          <Route path="/Synthora" element={<ProtectedRoute><AdminRoute><SynthoraHub /></AdminRoute></ProtectedRoute>}></Route>
          <Route path="/test-bench" element={<ProtectedRoute><DeveloperRoute><TestBenchPage /></DeveloperRoute></ProtectedRoute>}></Route>
          <Route path="/Synthora-legacy" element={<ProtectedRoute><AdminRoute><Synthora /></AdminRoute></ProtectedRoute>}></Route>
          <Route path="/settings/onboarding" element={<ProtectedRoute><OnboardingForm /></ProtectedRoute>}></Route>
          <Route path="/settings/firm-standards" element={<ProtectedRoute><CapabilityRoute feature="firmStandards"><FirmStandards /></CapabilityRoute></ProtectedRoute>}></Route>
          <Route path="/settings/programs-pipelines" element={<ProtectedRoute><CapabilityRoute feature="immigrationPrograms"><ProgramsPipelinesPage /></CapabilityRoute></ProtectedRoute>}></Route>
          <Route path="/settings/teach-program" element={<ProtectedRoute><CapabilityRoute feature="immigrationPrograms"><TeachProgramPage /></CapabilityRoute></ProtectedRoute>}></Route>
          <Route path="/settings/form-template/:templateId" element={<ProtectedRoute><FormDetails /></ProtectedRoute>}></Route>
          {/* A staffing agency's own requisition board. The page itself refuses anyone whose
              discipline is not Staffing & Labour Hire, so it needs no extra route guard. */}
          <Route path="/settings/positions" element={<ProtectedRoute><StaffingPositionsPage /></ProtectedRoute>}></Route>
          <Route path="/settings/tokens" element={<ProtectedRoute><TokenSettings /></ProtectedRoute>}></Route>
          <Route path="/settings/campaigns" element={<ProtectedRoute><CampaignsPage /></ProtectedRoute>}></Route>
          <Route path="/profile" element={<ProtectedRoute><AdminRoute><ProfilePage /></AdminRoute></ProtectedRoute>}></Route>
          <Route path="/admin" element={<AdminRoute><AdminPanel /></AdminRoute>}></Route>
          <Route path="/contact-us" element={<ProtectedRoute><ContactUs /></ProtectedRoute>}></Route>
          <Route path="/payments" element={<ProtectedRoute><PaymentsManagement /></ProtectedRoute>}></Route>
          <Route path="/agreements" element={<ProtectedRoute><Agreements /></ProtectedRoute>}></Route>
          <Route path="/network" element={<ProtectedRoute><NetworkPage /></ProtectedRoute>}></Route>
          <Route path="/agent" element={<ProtectedRoute><AgentPage /></ProtectedRoute>}></Route>
          <Route path="/agent/live-check" element={<ProtectedRoute><LiveCheckPage /></ProtectedRoute>}></Route>
          <Route path="/agent/history" element={<ProtectedRoute><AgentHistoryPage /></ProtectedRoute>}></Route>
          <Route path="/agent/build" element={<ProtectedRoute><AdminRoute><AgentBuilderPage /></AdminRoute></ProtectedRoute>}></Route>
          <Route path="/copilot" element={<ProtectedRoute><CoPilotPage /></ProtectedRoute>}></Route>
          <Route path="/video-call/:expertId/:channelName" element={<ProtectedRoute><VideoCallPage /></ProtectedRoute>} />
          <Route path="/whiteboard/:roomId" element={<WhiteboardPage />} />
          {/* Password-protected form filling page - no Auth0 required, uses password from email */}
          <Route path="/fill-form/:sessionId" element={<FormFillingGate />} />
          {/* Service questionnaire page - public access via session link */}
          <Route path="/service-questionnaire/:sessionId" element={<ServiceQuestionnairePage />} />
          {/* Unsubscribe page - public access via email link */}
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          {/* Referral consent - public access via tokenized email link */}
          <Route path="/referral-consent/:token" element={<ReferralConsentPage />} />
          {/* Feedback detail page - view feedback and comment thread */}
          <Route path="/feedback/:id" element={<ProtectedRoute><FeedbackDetailPage /></ProtectedRoute>} />
          {/* Team member invitation pages - no Auth0 required */}
          <Route path="/accept-invite" element={<AcceptInvitePage />} />
          <Route path="/reset-password" element={<AcceptInvitePage />} />
          {/* Member login - requires Auth0 first, then member credentials */}
          <Route path="/member-login" element={<MemberLoginPage />} />
          {/* Legacy login page - redirect to Auth0 or member login */}
          <Route path="/login" element={<TeamLoginPage />} />
          <Route path="/monday-calendar-test" element={<ProtectedRoute><MondayCalendarTest /></ProtectedRoute>}></Route>
          <Route path="/monday-scheduler" element={<ProtectedRoute><MondayCalendarScheduler /></ProtectedRoute>}></Route>
          {/* Flow Builder Prototypes - Testing 3 different approaches */}
          <Route path="/flow-builder/react-flow" element={<ProtectedRoute><FlowBuilderReactFlow /></ProtectedRoute>}></Route>
          <Route path="/flow-builder/blocks" element={<ProtectedRoute><FlowBuilderBlocks /></ProtectedRoute>}></Route>
          <Route path="/flow-builder/forms" element={<ProtectedRoute><FlowBuilderForms /></ProtectedRoute>}></Route>
        </Routes>
      </section>
    </div>
  );
}